export { ProductAdditionalDetails } from './ProductAdditionalDetails';
